module.exports = __webpack_public_path__ + "static/img/hero_iphone.1346a39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/Music/imgs/hero_iphone.jpg
// module id = qnXW
// module chunks = 0